import React from 'react';

const items = [
  { icon: '⭐', text: '4.9 Rating on Google' },
  { icon: '✦', text: '132+ Happy Clients' },
  { icon: '📍', text: 'Wuse 2, Abuja' },
  { icon: '✦', text: 'Premium Hair & Spa' },
  { icon: '💅', text: 'Walk-ins Welcome' },
  { icon: '✦', text: 'Book via WhatsApp' },
  { icon: '✂️', text: 'Expert Stylists' },
  { icon: '✦', text: 'Mon–Sat 8am–8pm' },
];

const Dot = () => (
  <span className="inline-block w-1.5 h-1.5 rounded-full bg-roseGold/60 mx-4 flex-shrink-0 align-middle" />
);

export default function MarqueeBar() {
  const repeatedItems = [...items, ...items]; // duplicate for seamless loop

  return (
    <section id="marquee" className="relative overflow-hidden py-4" style={{ background: '#111010' }}>
      {/* Left fade */}
      <div className="absolute left-0 top-0 h-full w-20 z-10 pointer-events-none"
        style={{ background: 'linear-gradient(to right, #111010, transparent)' }} />
      {/* Right fade */}
      <div className="absolute right-0 top-0 h-full w-20 z-10 pointer-events-none"
        style={{ background: 'linear-gradient(to left, #111010, transparent)' }} />

      <div className="flex overflow-hidden">
        <div className="animate-marquee flex items-center flex-shrink-0" aria-hidden="true">
          {repeatedItems.map((item, i) => (
            <React.Fragment key={i}>
              <span className="flex items-center gap-2 flex-shrink-0">
                <span className="text-sm">{item.icon}</span>
                <span className="font-inter text-xs sm:text-sm font-medium tracking-widest text-roseGold uppercase whitespace-nowrap">
                  {item.text}
                </span>
              </span>
              <Dot />
            </React.Fragment>
          ))}
        </div>
        {/* Duplicate for seamless loop */}
        <div className="animate-marquee flex items-center flex-shrink-0" aria-hidden="true">
          {repeatedItems.map((item, i) => (
            <React.Fragment key={`b-${i}`}>
              <span className="flex items-center gap-2 flex-shrink-0">
                <span className="text-sm">{item.icon}</span>
                <span className="font-inter text-xs sm:text-sm font-medium tracking-widest text-roseGold uppercase whitespace-nowrap">
                  {item.text}
                </span>
              </span>
              <Dot />
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}
